export const GET_PROFILE_BATTLES = 'PROFILE_GET_PROFILE_BATTLES'
export const SET_PROFILE_BATTLES = 'PROFILE_SET_PROFILE_BATTLES'

export const getProfileBattles = () => {
  return { type: GET_PROFILE_BATTLES }
}
export const setProfileBattles = (data) => {
  return { type: SET_PROFILE_BATTLES, data }
}
